import { parseProject, type Project } from '@finsim/model';
import { authApi } from '../../shared/api/auth';
import { remoteProjects, type RemoteMeta } from '../../shared/api/remote-projects';
import { local } from './store';

/** Saves a remote copy locally as clean (the user's, at `version`). */
export async function storeRemote(
  project: Project,
  meta: RemoteMeta,
  userId: string,
): Promise<void> {
  await local().save(project, meta.updatedAt);
  await local().setSync(project.id, { ownerId: userId, remoteVersion: meta.version, dirty: false });
}

/**
 * A project that isn't in this browser yet (e.g. a link opened on a new device): downloaded from
 * the account if signed in. Null when there's no session, no API or no such project.
 */
export async function downloadProject(id: string): Promise<Project | null> {
  try {
    const user = await authApi.me();
    if (!user) return null;
    const remote = await remoteProjects.get(id);
    const parsed = parseProject(remote.project);
    if (!parsed.success) return null;
    await storeRemote(parsed.data, remote.meta, user.id);
    return parsed.data;
  } catch {
    return null;
  }
}
